module.exports = __webpack_public_path__ + "static/media/sz.464385ad.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sz.svg
// module id = 2219
// module chunks = 0